export const initialModeData = {
    addressId: 0,
    companyId: 0,
    modeType: "",
    creditLimit: 0,
    creditTerms: 0,
    paymentTermsId: 0,
    paymentTerms: "",
    creditStatus: "",
    creditApprovedDate: null,
    creditApprovedBy: "",
    creditAlertThresholdsWarningLevel: 0,
    creditAlertThresholdsCriticalLevel: 0,
    creditAlertThresholdsAutoBlockAt: 0,
    allowCreditLimitOverride: false,
    emailNotificationOnThreshold: false,
    sopBookingRulesRequirePoNumberForBooking: false,
    sopBookingRulesRequireDocumentsBeforeRelease: false,
    sopBookingRulesAutoSendBookingConfirmation: false,
    sopBookingRulesRequireRateApprovalBeforeBooking: false,
    sopDocumentRulesAutoGenerateHblHawb: false,
    sopDocumentRulesRequireCustomsClearanceDocs: false,
    sopDocumentRulesSendArrivalNotice: false,
    sopDocumentRulesAutoSendDeliveryOrder: false,
    sopSpecialInstructionsOrNotes: "",
    accessControlsBookingApprovalRequiredId: 0,
    accessControlsBookingApprovalRequired: "",
    accessControlsCreditOverrideApprovalId: 0,
    accessControlsCreditOverrideApproval: "",
    governanceNotes: "",
    isActive: true,
    createdBy: "",
};

export const initialFormData = {
    addressId: 0, // 👈 hidden variable
    companyID: 0,
    addressIdSelected: 0,
    edicode: "",
    ddlofficetype: "",
    ddlofficetype2: "0",
    companyname: "",
    // ddlsalesperson: '',
    ddlsalesperson: [],
    companyname2: "",
    address1: "",
    country: "",
    postalcode: "",
    city: "",
    state: "",
    specialnotesexport: "",
    specialnotesimport: "",
    OCEAN_IMPORT: false,
    OCEAN_EXPORT: false,
    AIR_EXPORT: false,
    AIR_IMPORT: false,
    DOMESTIC_TOWING: false,
    WAREHOUSING: false,
    DISTRIBUTION: false,
    mastercompanyid : 0,
    shisignee: { input: "", id: "", list: [] },
    trupper: { input: "", id: "", list: [] },
    concker: { input: "", id: "", list: [] },
    carrier: { input: "", id: "", list: [] },
};

export const generateCompanyPayload = (
    bookingData,
    authUser,
    salesPersonList,
    formData,
) => {
    const companyPayload = {
        id: formData?.companyID || 0,
        OFFICECODE: formData.ddlofficetype,
        CUSTOMERNAME: formData.companyname,
        ACCOUNTNUMBER: formData.edicode,
        FMCNUMBER: formData.fmc,
        USPPICONTACTNAME: formData.usppicontactname,
        USPPIPHONENUMBER: formData.usppiphone,
        // SALESPERSONID: Number(formData.ddlsalesperson),
        // SALESPERSON: salesPersonList?.find(s => s.salesPersonId == formData.ddlsalesperson)?.salesPerson || "",
        // SALESPERSONIDS: formData.ddlsalesperson, // [1,2,3]
        SALESPERSONIDS: formData.ddlsalesperson.join(","),
        SALESPERSONS: salesPersonList
            ?.filter((s) => formData.ddlsalesperson.includes(s.salesPersonId))
            .map((s) => s.salesPerson)
            .join(", "),
        CARRIERSCACCODE: formData.scaccode,
        carriercontract: formData?.carriercontract,

        COORDINATOR: formData.coordinatname,
        COORDINATOREMAIL: formData.coordinateemail,
        IDTYPE: formData.ddlidentityType,
        IDNO: formData.identityno,

        // VENDORTAXID:formData.importtaxid,
        INSURANCE_VALID_DATE: formData?.insurancevaliddate || null,
        INSURANCE_EXPIRE_DATE: formData?.insuranceexpirydate || null,
        COORDINATORPHONE: formData.coordinatorphone,
        PROFITMARGINTYPE: formData.ddlprofitmargintype || 0,
        CONSIGNEETYPE: formData.ddlconsigneeType,

        ISDPLACTIVE: formData.isdplactive || false,
        OVERRIDEDPL: formData?.overridedpl || false,

        SPECIALNOTES: formData.notes,
        CREATEDBY: authUser.username,
        modifiedby: authUser.username,
        mastercompanyid: authUser?.companyId,

        USPPI_Email: formData.usppiemail,
        EORI_Number: formData.eorinumber,
        Import_Tax_ID: formData.importtaxid,
    };

    return companyPayload;
};

export const generateAddressPayload = (bookingData, authUser, formData) => {
    const addressPayload = {
        addressid: formData?.addressId,
        companyid: formData?.companyID || 0,
        ADDRESSNAME: formData.companyname2,
        officetype: formData?.ddlofficeType2,
        ADDRESS1: formData.address1,
        ADDRESS2: formData.address2,
        ADDRESS3: formData.address3,
        COUNTRY: formData.country,
        ADD_POSTALCODE: formData.postalcode,
        ADD_CITY: formData.city,
        ADD_STATE: formData.state,
        PROVINCE: formData.province,
        CONTACTNAME: formData.contactperson,
        CONTACTPERSONPOSITIONID: formData.ddlcontactpersonposition || 0,
        EMAIL: formData.email,
        ADD_PHONENO: formData.officetel,
        ACCOUNTNO: formData.customersapact,
        VENDORACCOUNTNO: formData.vendorsapact,
        QUICKBOOKCUSTOMERID: formData.quickbookcstid || 0,
        QUICKBOOKVENDORID: formData.quickbookvendorid || 0,
        ADD_FAXNO: formData.fax,
        ALTERNATIVE_PHONENO: formData.tel2,

        ADD_TOLLFREENO: formData.tollfree,
        ALTERNATIVE: formData.altemail,
        ACCOUNTINGEMAIL: formData.accountingemail,

        VENDORELIGIBLEFOR1099: formData.chkvendoreligible || false,
        VENDORTAXID: formData.vendortaxid,
        ADDRESSREVIEW: formData.printaddress,
        SELECTACCOUNTADDRESSID: formData.ddlsalectaccountaddress || 0,
        PRINTADDRESSACCOUNTING: formData.printaddressaccount,

        EXPORTER: formData.chkexporter || false,
        IMPORTER: false,
        BILLTOPARTY: formData.chkbilltoparty || false,
        FORWARDER: formData.chkforwarder || false,
        CONSIGNEE: formData.chkconsignee || false,
        NOTIFY: formData.chknotify || false,
        AGENT: formData.chkagent || false,
        VENDOR: formData.chkvendor || false,
        OCEAN_CARRIER: formData.chkcarrier || false,
        AIR_CARRIER: formData.chkairline || false,
        TRUCKER: formData.chktrucker || false,
        TOWING: formData.chktowing || false,
        WAREHOUSE: formData.chkwarehouse || false,
        SUPPLIER: formData.chksupplier || false,
        BROKER: formData.chkbroker || false,
        OTHER: formData.chkother || false,

        CURRENCY: "USD",
        CREATEDBY: authUser.username,
        modifiedby: authUser.username,
        mastercompanyid: authUser.companyId,
        //   CREATEDBY: "ADMIN"
        OCEAN_IMPORT: formData?.OCEAN_IMPORT || false,
        OCEAN_EXPORT: formData?.OCEAN_EXPORT || false,
        AIR_EXPORT: formData?.AIR_EXPORT || false,
        AIR_IMPORT: formData?.AIR_IMPORT || false,
        DOMESTIC_TOWING: formData?.DOMESTIC_TOWING || false,
        WAREHOUSING: formData?.WAREHOUSING || false,
        DISTRIBUTION: formData?.DISTRIBUTION || false,
        prospect: formData?.chkprospect || false,
        bco: formData?.chkbco || false,
        parentcompany: formData?.parentcompany || "",
        alternativE_EMAILID: formData?.altemail || "",
        DoNotSendNotification: formData?.dontsendnotification || false,
        NotificationEmail: formData?.notificationemail || "",
        PARENTCOMPANY: formData?.parentcompany || "",
        FIRMSCODE: formData?.firmcode || "",
    };

    return addressPayload;
};

export const companyMap = {
    companyID: "id",
    companyname: "customername",
    ddlidentityType: "idtype",
    identityno: "idno",
    edicode: "accountnumber",
    fmc: "fmcnumber",
    usppicontactname: "usppicontactname",
    usppiphone: "usppiphonenumber",
    scaccode: "carrierscaccode",
    carriercontract: "carriercontract",
    notes: "specialnotes",
    insurancevaliddate: "insurancE_VALID_DATE",
    insuranceexpirydate: "insurancE_EXPIRE_DATE",
    // ddlsalesperson:'salespersonid',

    ddlprofitmargintype: "profitmargintype",
    ddlconsigneeType: "consigneetype",
    isdplactive: "isdplactive",
    overridedpl: "overridedpl",
    coordinatorphone: "coordinatorphone",
    coordinatname: "coordinator",
    coordinateemail: "coordinatoremail",
    ddlofficetype: "officecode",
    usppiemail: "USPPI_Email",
    eorinumber: "EORI_Number",
    importtaxid: "Import_Tax_ID",
    mastercompanyid: "mastercompanyid",

};

export const addressMap = {
    addressId: "addressid",
    ddlofficeType2: "officetype",
    companyname2: "addressname",
    country: "country",
    address1: "addresS1",
    address2: "addresS2",
    address3: "addresS3",
    city: "adD_CITY",
    state: "adD_STATE",
    postalcode: "adD_POSTALCODE",
    fax: "adD_FAXNO",
    tel2: "alternativE_PHONENO",
    tollfree: "adD_TOLLFREENO",
    province: "province",
    accountingemail: "accountingemail",
    altemail: "alternativE_EMAILID",
    contactperson: "contactname",
    ddlsalectaccountaddress: "selectaccountaddressid",
    ddlcontactpersonposition: "contactpersonpositionid",
    printaddress: "addressreview",
    printaddressaccount: "printaddressaccounting",
    email: "email",
    officetel: "adD_PHONENO",
    customersapact: "accountno",
    vendorsapact: "vendoraccountno",
    quickbookcstid: "quickbookcustomerid",
    quickbookvendorid: "quickbookvendorid",

    chkexporter: "exporter",
    chkbilltoparty: "billtoparty",
    chkforwarder: "forwarder",
    chkconsignee: "consignee",
    chknotify: "notify",
    chkagent: "agent",
    chkvendor: "vendor",
    chkcarrier: "oceaN_CARRIER",
    chkairline: "aiR_CARRIER",
    chktrucker: "trucker",
    chktowing: "towing",
    chkwarehouse: "warehouse",
    chksupplier: "supplier",
    chkbroker: "broker",
    chkother: "other",
    vendortaxid: "vendortaxid",
    chkvendoreligible: "vendoreligiblefoR1099",
    OCEAN_IMPORT: "OCEAN_IMPORT",
    OCEAN_EXPORT: "OCEAN_EXPORT",
    AIR_EXPORT: "AIR_EXPORT",
    AIR_IMPORT: "AIR_IMPORT",
    DOMESTIC_TOWING: "DOMESTIC_TOWING",
    WAREHOUSING: "WAREHOUSING",
    DISTRIBUTION: "DISTRIBUTION",
    chkbco: "bco",
    chkprospect: "prospect",
    dontsendnotification: "DoNotSendNotification",
    notificationemail: "NotificationEmail",
    parentcompany : "parentcompany",
    firmcode: "firmscode",

};

export const validationConfig = {
    //edicode: { required: true, label: "Edi Code" },
    ddlofficetype: { required: true, label: "Office Type" },
    companyname: { required: true, label: "Company Name" },
    ddlsalesperson: { required: true, label: "Sales Person" },
    companyname2: { required: true, label: "Company Name" },
    address1: { required: true, label: "Address1" },
    country: { required: true, label: "Country" },
    postalcode: { required: true, label: "Postal code" },
    city: { required: true, label: "City" },
    state: { required: true, label: "City" },
};

const formatDateForInput = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
};


export const setComplianceData_ = (data) => {
    const complianceData = {
        certificateID: data.certificateID || 0,
        custid: data.custid || 0,
        sales_Required: data.sales_Required || false,
        sales_Agree_Date_chk: data.sales_Agree_Date_chk || false,
        sales_Agreement_date: formatDateForInput(data.sales_Agreement_date) || null,
        sales_Attach: data.sales_Attach || false,
        forwarder_Licn_Confirmed: data.forwarder_Licn_Confirmed || false,
        forwarder_Licn_ConfirmDate:
            formatDateForInput(data.forwarder_Licn_ConfirmDate) || null,
        poaexpiry: data.poaexpiry || false,
        poaexpirydate: formatDateForInput(data.poaexpirydate) || null,
        poa_attach: data.poa_attach || false,
        poaalertemail: data.poaalertemail || "",
        coload_date_check: data.coload_date_check || false,
        coload_dateSent: formatDateForInput(data.coload_dateSent) || null,
        coload_Attach: data.coload_Attach || false,
        vend_Approved: data.vend_Approved || false,
        vend_Date_Approved: formatDateForInput(data.vend_Date_Approved) || null,
        vend_Attach: data.vend_Attach || false,
        ctpat_confirmed: data.ctpat_confirmed || false,
        ctpat_dateconfirmed: formatDateForInput(data.ctpat_dateconfirmed) || null,
        ctpat_attach: data.ctpat_attach || false,
        agent_due: data.agent_due || false,
        agent_corrupt: data.agent_corrupt || false,
        agent_attach: data.agent_attach || false,
        knownshipper: data.knownshipper || false,
        unknownshipper: data.unknownshipper || false,
        airattach: data.airattach || false,
        creditAgreement: data.creditAgreement || false,
        creditAgreementDate: formatDateForInput(data.creditAgreementDate) || null,
        creditAgreementAttach: data.creditAgreementAttach || false,
        loi: data.loi || false,
        loiAgreementAttach: data.loiAgreementAttach || false,
        loiDate: formatDateForInput(data.loiDate) || null,
        poa_Foreign_Certificate_Attach:
            data.poa_Foreign_Certificate_Attach || false,
        waiverOfSendingDocuments_Attach:
            data.waiverOfSendingDocuments_Attach || false,
        coLoadAgreementOnFile: data.coLoadAgreementOnFile || "",
    };

    return complianceData;
};

export const initialComplianceData = {
    custID: 0,
    sales_Required: false,
    sales_Agree_Date_chk: false,
    sales_Agreement_date: null,
    sales_Attach: false,
    forwarder_Licn_Confirmed: false,
    forwarder_Licn_ConfirmDate: null,
    poaexpiry: false,
    poaexpirydate: null,
    poa_attach: false,
    poaalertemail: null,
    coload_date_check: false,
    coload_dateSent: null,
    coload_Attach: false,
    vend_Approved: false,
    vend_Date_Approved: null,
    vend_Attach: false,
    ctpat_confirmed: false,
    ctpat_dateconfirmed: null,
    ctpat_attach: false,
    agent_due: false,
    agent_corrupt: false,
    agent_attach: false,
    knownshipper: false,
    unknownshipper: false,
    airattach: false,
    creditAgreement: false,
    creditAgreementDate: null,
    creditAgreementAttach: false,
    loi: false,
    loiDate: null,
    loiAgreementAttach: false,
    poa_Foreign_Certificate_Attach: false,
    waiverOfSendingDocuments_Attach: false,
    coLoadAgreementOnFile: null,
};

export const initialaddress = {
    addressId: 0,
    addressIdSelected: 0,
    ddlofficetype2: 0,
    companyname2: "",
    country: "",
    address1: "",
    address2: "",
    address3: "",
    city: "",
    state: "",
    postalcode: "",
    fax: "",
    tollfree: "",
    province: "",
    accountingemail: "",
    altemail: "",
    contactperson: "",
    ddlsalectaccountaddress: 0,
    ddlcontactpersonposition: 0,
    printaddressaccount: "",
    email: "",
    officetel: "",
    customersapact: "",
    vendorsapact: "",
    quickbookcstid: 0,
    quickbookvendorid: 0,

    chkexporter: false,
    chkbilltoparty: false,
    chkforwarder: false,
    chkconsignee: false,
    chknotify: false,
    chkagent: false,
    chkvendor: false,
    chkcarrier: false,
    chkairline: false,
    chktrucker: false,
    chktowing: false,
    chkwarehouse: false,
    chksupplier: false,
    chkbroker: false,
    chkother: false,
    vendortaxid: "",
    chkbco: false,
    chkvendoreligible: false,
    chkprospect: false,
};

export const entityType = [
    { name: "chkexporter", label: "Exporter" },
    { name: "chkbilltoparty", label: "Bill to Party" },
    { name: "chkforwarder", label: "Forwarder" },
    { name: "chkconsignee", label: "Consignee" },
    { name: "chknotify", label: "Notify" },
    { name: "chkagent", label: "Agent" },
    { name: "chkvendor", label: "Vendor" },
    { name: "chkcarrier", label: "Carrier" },
    { name: "chkairline", label: "Airline" },
    { name: "chktrucker", label: "Trucker" },
    { name: "chktowing", label: "Towing" },
    { name: "chkwarehouse", label: "Warehouse" },
    { name: "chksupplier", label: "Supplier" },
    { name: "chkbroker", label: "Broker" },
    { name: "chkbco", label: "BCO" },
    { name: "chkprospect", label: "Prospect" },
    { name: "chkother", label: "Other" },
];
